import NiceSelect from 'nice-select2';
import { lenis } from '../animations/ScrollLenis';

export default class Selects {
    constructor(selector = '.js-select') {
        this.selector = selector;
        this.init();
    }

    init() {
        document.querySelectorAll(this.selector).forEach((select) => {
            if (select.classList.contains('nice-select-initialized')) return;

            if (select.niceSelectInstance) {
                select.niceSelectInstance.destroy();
            }

            const niceSelectInstance = new NiceSelect(select, {
                searchable: false
            });

            select.niceSelectInstance = niceSelectInstance;
            select.classList.add('nice-select-initialized');

            this.decorateOptions(select);
            this.handleLenisFixes(select);
        });
    }

    decorateOptions(select) {
        const niceSelect = select.parentElement.querySelector('.nice-select');
        if (!niceSelect) return;

        niceSelect.querySelectorAll('.option, .current').forEach((el) => {
            const rawText = el.textContent.trim();
            const match = rawText.match(/\((\d+)\)$/);

            if (match) {
                const count = match[1];
                if (!el.innerHTML.includes('category_count')) {
                    const label = rawText.replace(`(${count})`, '').trim();
                    el.innerHTML = `${label} <span class="category_count">${count}</span>`;
                }
            }
        });
    }

    handleLenisFixes(select) {
        const dropdown = select.parentElement.querySelector('.nice-select');
        if (!dropdown) return;

        dropdown.setAttribute('data-lenis-prevent', '');
        dropdown.addEventListener('mousedown', () => {
            lenis?.stop();
        });
        document.addEventListener('mouseup', () => {
            lenis?.start();
        });

        select.addEventListener('click', () => {
            requestAnimationFrame(() => {
                lenis?.raf(performance.now());
            });
        });
    }
}